module.exports = __webpack_public_path__ + "static/img/databackground.d79db4e4.png";